import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IAppSettings {
  defaults_dpdg_speed: number | null;
  base_price: string | null;
  base_duration: number | null;
  defaults_dpdg_size: number | null;
  defaults_dpdg_background: string | null;
}

interface IAppSettingsState {
  settings: IAppSettings | null;
}

const initialState: IAppSettingsState = {
  settings: null,
};

const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setSettings(state, action: PayloadAction<IAppSettings>) {
      state.settings = action.payload;
    },
  },
});

export const { setSettings } = appSettingsSlice.actions;
export default appSettingsSlice.reducer;
